// extracted by mini-css-extract-plugin
module.exports = {"link":"style_link_3puCT","smalltext":"style_smalltext_NKfL1"};